import { giphyDarkestGrey, giphyIndigo } from '@giphy/colors'
import { Button } from 'shared/components/buttons'
import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

const Container = styled.div`
    align-items: center;
    animation: ${fadeIn} 0.2s ease-out;
    background: rgba(0, 0, 0, 0.8);
    box-sizing: border-box;
    display: flex;
    height: 100%;
    left: 0;
    justify-content: center;
    padding: 20px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 999;
`

const Peeker = styled.img`
    left: 50%;
    margin-left: -50px;
    pointer-events: none;
    position: absolute;
    top: -97px;
    width: 100px;
`

const Modal = styled.div`
    background: ${giphyDarkestGrey};
    border-radius: 4px;
    color: #fff;
    padding: 25px;
    position: relative;
    text-align: center;
`

const Title = styled.h1`
    font-size: 20px;
    font-weight: bold;
    line-height: 1.2;
    margin-bottom: 15px;
`

const Description = styled.p`
    font-size: 16px;
    margin-bottom: 30px;
`

const GotIt = styled(Button)`
    background: ${giphyIndigo};
    border-radius: 2px;
    min-width: 170px;
`

type Props = {
    onClose: () => void
}

const BackdropMakerModal = ({ onClose }: Props) => (
    <Container>
        <Modal>
            <Title>Sorry, Backdrop is Desktop Only!</Title>
            <Description>Visit this page from your desktop computer to use GIPHY Backdrop.</Description>
            <GotIt onClick={onClose}>Got it</GotIt>
            <Peeker src="/static/img/zoom-peeker-dude.gif" alt="" />
        </Modal>
    </Container>
)

export default BackdropMakerModal
